<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default  {
  name:  'App',
  created(){

  }
}
</script>

<style lang="scss">

@import './common/scss/common.scss';
@import './common/scss/theme.scss';

#app{
  width: 100%;
  height: 100vh;
  overflow-x: auto;
}
.icon {
  width:18px;
  height: 18px;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.cabinet-status-notify {
  .el-notification__title {
    font-size: 20px;
  }
  .el-notification__content {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue